import { jsxs as E, Fragment as _, jsx as r } from "react/jsx-runtime";
import { m as g } from "motion/react";
import { mapResponseTrailerToTrailer as x, mapNearbyTrailerToTrailer as B } from "../../../helpers/trailer-rental-mapper.js";
import f from "../trailer-card-list/trailer-card-list.js";
import O from "../trailer-rental-search-widget/trailer-rental-search-widget.js";
import { isArrayWithItems as T } from "../../../../../helpers/array-helper.js";
import { useTranslation as v } from "react-i18next";
import { TrailerType as I, trailerTypeConfig as c } from "../../../helpers/trailer-filter-helper.js";
import { TrailerTypeFilterRadioButtons as G } from "../trailer-type-filter-radio-buttons/trailer-type-filter-radio-buttons.js";
import { AlertSummary as H } from "../../../../../components/elements/alert-summary/alert-summary.js";
import A from "./list-available-trailers.module.less.js";
import { BearLoader as W } from "../../../../../components/elements/bear-loader/bear-loader.js";
import { useAnimateFadeIn as M } from "../../../../../animation/animation.js";
import { getTrailerRentalLocationDisplayName as b } from "../../../helpers/trailer-rental-helper.js";
import { orderBy as j } from "lodash-es";
const k = (o, a) => o.filter((i) => {
  if (!a)
    return !0;
  if (a === I.TRAILER) {
    for (const [R, n] of Object.entries(c))
      if (R !== I.TRAILER && n) {
        for (const s of n)
          if (s === i.trailer.id)
            return !1;
      }
    return !0;
  }
  return c[a]?.includes(i.trailer.id);
}), tr = ({
  availableTrailers: o,
  nearbyAvailableTrailers: a,
  trailerTypeFilter: i,
  availableStations: R,
  selectedRentalStartDate: n,
  selectedRentalEndDate: s,
  selectedStation: d,
  widgetTitle: u,
  widgetText: N,
  isLoading: l,
  hasApiError: S,
  dispatch: m
}) => {
  const { t: e } = v(), y = o?.map((t) => ({
    trailer: x(t),
    onClick: () => m({ type: "SELECT_TRAILER", payload: { trailer: t } }),
    notAvailable: !T(t.freeTimeSlots)
  })), C = a?.map((t) => ({
    trailer: B(t),
    onClick: () => m({ type: "SELECT_TRAILER", payload: { trailer: t.trailer } }),
    notAvailable: !T(t.trailer.freeTimeSlots)
  })), h = k(y, i), p = j(C, ["trailer.distanceInMeters"], ["asc"]), D = () => {
    m({ type: "CHANGE_STEP", payload: { step: "SHOW_SEARCH_WIDGET" } });
  }, Y = M({ duration: 0.3 }), L = b(d);
  return /* @__PURE__ */ E(_, { children: [
    /* @__PURE__ */ r(
      O,
      {
        startDate: n ? n.format("YYYY-MM-DD") : void 0,
        endDate: s ? s.format("YYYY-MM-DD") : void 0,
        setCurrentStation: () => {
        },
        currentStation: d,
        onDateChange: () => {
        },
        availableStations: R,
        collapsed: !0,
        onChangeBooking: D,
        title: u,
        textStepTwo: N,
        hasApiError: !1
      }
    ),
    /* @__PURE__ */ E("div", { className: "padded-sides max-width centered", children: [
      S && /* @__PURE__ */ r("div", { className: A.alertWrapper, children: /* @__PURE__ */ r(
        H,
        {
          heading: e("TRAILER_RENTAL_ERROR_FETCH_AVAILABLE_TRAILERS"),
          messages: [{ text: e("ERROR_GENERIC_API_ERROR_BODY") }],
          className: A.alertSummary,
          type: "error"
        }
      ) }),
      l && /* @__PURE__ */ r(g.div, { ...Y, className: A.loaderWrapper, children: /* @__PURE__ */ r(W, { text: e("TRAILER_RENTAL_LOADING_TRAILERS_LABEL") }) }),
      T(o) && !l && /* @__PURE__ */ E(_, { children: [
        /* @__PURE__ */ r(
          G,
          {
            dispatch: m,
            availableTrailers: o,
            trailerTypeFilter: i
          }
        ),
        /* @__PURE__ */ r(
          f,
          {
            heading: e("TRAILER_RENTAL_TRAILER_LIST_HEADING", { stationName: L }),
            text: e("TRAILER_RENTAL_TRAILER_LIST_TEXT"),
            cardList: h
          }
        )
      ] }),
      T(p) && !l && /* @__PURE__ */ r(
        f,
        {
          heading: e("TRAILER_RENTAL_TRAILER_LIST_HEADING_NEARBY_TRAILERS", { stationName: L }),
          text: e("TRAILER_RENTAL_TRAILER_LIST_TEXT"),
          cardList: p
        }
      )
    ] })
  ] });
};
export {
  tr as ListAvailableTrailers,
  tr as default
};
